import { CanAccess, useShowContext } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { EditButton } from "@/components/admin/edit-button";
import { RecordField } from "@/components/admin/record-field";
import { Show } from "@/components/admin/show";

import type { Developer } from "../types";
import { AuthorizationToSellStatusPill } from "./AuthorizationToSellStatusPill";
import { DeveloperFiscalSection } from "./DeveloperFiscalSection";

/**
 * Read-only detail view (Almikia Epic E1b, TASK-031): every role can open a
 * developer here (list rowClick always routes to "show"); direccion gets an
 * Editar button leading to the existing edit page, every other role gets
 * none. The "Datos fiscales" section (TASK-034) only mounts — and only
 * fetches `developer_fiscal_profiles` — for direccion and contabilidad.
 */
export const DeveloperShow = () => (
  <Show actions={<DeveloperShowActions />}>
    <DeveloperShowLayout />
  </Show>
);

const DeveloperShowLayout = () => {
  const { record, isPending } = useShowContext<Developer>();

  if (isPending || !record) return null;

  return (
    <Card>
      <CardContent className="flex flex-col gap-4">
        <RecordField source="legal_name" />
        <RecordField source="authorization_to_sell_status">
          <AuthorizationToSellStatusPill />
        </RecordField>
        <CanAccess resource="developer_fiscal_profiles" action="show">
          <DeveloperFiscalSection developerId={record.id} />
        </CanAccess>
      </CardContent>
    </Card>
  );
};

const DeveloperShowActions = () => (
  <CanAccess resource="developers" action="edit">
    {/* This screen's single main action (design-system.md section 3/8): the
        next step for a developer's file is to edit it, so "Editar" gets the
        gradient primary style (TASK-038), matching DealShow/lead show. */}
    <EditButton variant="gradient" />
  </CanAccess>
);
